import React from 'react';
import { useParams } from 'react-router';

import { useGetVariantInterpretationZoneQuery } from '../../api/variantApi';

const ClassificationTitle = () => {
  const { vid } = useParams();
  const { data: interpretationZoneData } = useGetVariantInterpretationZoneQuery(
    { variant_id: vid },
    { skip: !vid },
  );

  return (
    <div className="interpretation__classification">
      <div className="interpretation__classification-title">
        Autocalculated Bayesian ACMG/AMP classification
      </div>
      {interpretationZoneData?.classification ? (
        <div className="interpretation__classification-result">
          <span className="interpretation__classification-value">
            {interpretationZoneData?.classification}
          </span>
          <span className="interpretation__classification-post-p">
            (post_P = {interpretationZoneData?.post_p})
          </span>
        </div>
      ) : (
        <div className="interpretation__classification-result">n/a</div>
      )}
    </div>
  );
};

export default ClassificationTitle;
